export const appTypesOptions = [
  { name: 'Mobile', value: 'Mobile' },
  { name: 'Desktop', value: 'Desktop' },
  { name: 'Web', value: 'Web' },
];
